<div class="breadcrumb">
  <ul class="breadcrumb__wrapper">
    @let computedList = items();
    @let showHomeIcon = homeIcon();
    @let lastIndex = computedList.length - 1;

    @if (showHomeIcon) {
      <evc-breadcrumb-item
        [homeIcon]="true"
        [size]="size()"
        (itemSelected)="onHomeSelect()" />
    }

    @for (item of computedList; let i = $index; track item.id) {
      @if (i !== lastIndex && (!loading() || i === 0)) {
        <evc-breadcrumb-item
          [link]="item.link"
          [size]="size()"
          (itemSelected)="this.itemSelected.emit(item)">
          {{ item.name }}
        </evc-breadcrumb-item>
      } @else if (i === lastIndex && showCurrentLocation() && !loading()) {
        <evc-breadcrumb-item
          [current]="true"
          [size]="size()">
          {{ item.name }}
        </evc-breadcrumb-item>
      }
    }
  </ul>
</div>
